import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import generate from 'firebase-auto-ids'
import { Modal } from 'wix-style-react'
import _ from 'lodash'

// import { deleteTemporaryIntegrationData } from 'controllers/logic'
import * as integrationType from 'constants/integrationType'
import MobileAppParamsModal from './mobileAppWizard/MobileAppParamsModal'
import { createCustomFields } from 'templates/app-website/template/mobileApp'

class MobileAppWizard extends Component {

  constructor (props) {
    super(props)

    const id = generate(_.now())

    this.state = {
      appId: id
    }
  }

  handleCreateApp = (info, platform) => {
    const { appId } = this.state
    const customFields = createCustomFields(info, platform === 'ios')
    const appSettings = {
      integration: integrationType.MOBILE_APP,
      platform: platform,
      appId: info.appId
    }
    customFields.appSettings = appSettings
    const appIdDots = `${platform}.${info.appId}`
    const appName = _.join(_.split(appIdDots, '.'), '_')
    this.props.handleCreateApp(appId, appName, customFields)
  }

  onChangeInstaName = (v) => this.setState({instaName: v})
  onChangeAppName = (v) => this.setState({appName: v})

  renderContent () {
    const { handleCancel } = this.props
    return (
      <MobileAppParamsModal
        handleCancel={handleCancel}
        handleCreateApp={this.handleCreateApp}
      />
    )
  }

  render () {
    return (
      <Modal zIndex={1000000} isOpen contentLabel=''>
        {this.renderContent()}
      </Modal>
    )
  }
}

MobileAppWizard.propTypes = {
  templateId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  handleCreateApp: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  user: state.user,
})

export default connect(mapStateToProps)(MobileAppWizard)



// WEBPACK FOOTER //
// ./src/components/dashboard/MobileAppWizard.js